var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPanelBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.155518,
    y: 0.986572,
    width: 37.7871,
    height: 44.7918,
    rx: 10,
    fill: "#5387FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.76392,
    y: 9.15796,
    width: 24,
    height: 28.4489,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_296_21382",
    transform: "translate(-0.0926859) scale(0.0493905 0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_296_21382",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmDAIKARPzAoL8AAAC3klEQVRIx81Uyyu0YRT/nVcug4zJ4kUjuQxp3IaiXEIpC7KwUUrxH6CslJJsLNioKWtJmmE0VhSRUjbIMK5ZIcXCDvH8vsWDIffPp76zeZ/znHN+5zy/854D/E9CVleTNTXfiTE+BiwuJuvrQxd2O5iS8qSqhgayuPgHFUdHkysrpMWiAfPzqQoKtM1i0bbo6I8w5NMkqrQUOD6GVFYCLhcgAq6vA0tLQFqaGGtr36KIyuEg3W4q0wyV4fEAdjvo9wNeL8Ruh0xNhWJMk3S7yYyMr1GjKiqoBgepsrLIhQUyPv41fTYbubBAlZlJNThIlpf/RQ88HqrMzPcLycoiJya+RVEIPCoKtFrFODx8z0eM/X3AaiXDwr6UgHS5qObnyelp0DQhJyefP/P0FDBNcnpax7pcX6THYiFnZz/38/mowsO/Rvqr4OTkn/q8mAOquDjI2BgeBuvbIisrIn19H1TT20s2Nelki4tUERGPc6HvWlupWlu178wMVWws6XRSjY7qu/FxsqjoOeZTk6msVqC2FvD5yOxsyNGRGLe3kLw8IBB4Xc7mJiQ/X2R7G3A49Drp6QEGBt5MAOnsBIaGRJQCmpvByUltyM0Ft7ZeJ9jY0KsDgPh8QGOjyPExGAxS1dW96AFpswHBIBgIACRQWKirvruDOJ3A4SF4cwNJStLPPTuDxMTo9bG3p8+pqeDOjj5HRgIlJSL39w/c9/eTjY2aqtzcR861Pj8fOj/vgQjV3FzI5vWSiYna1tVFtrcDgEHGx4NlZYDfr9/U3AxoeqgiIyHX12/+MEJClHqaARkfB1padLaREaCtjYyJMYDubmB4WITUoVVVwPKyDsrJAXd33/8vg0EgO1uD+v2AZkGM21vA7QY6OoS8uND7HYCEhQHp6eDBgdatViAqCjw/14AJCfp7eantpglcX4NXV1p3OMCjI0ApQARSWIjnPP5roZqbMyCrq7+V4Inq35Q/fKqB++SZjWUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTItMDJUMTA6MDE6MTkrMDA6MDCfQHijAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTEyLTAyVDEwOjAxOjE5KzAwOjAw7h3AHwAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMi0xMi0wMlQxMDowMToxOSswMDowMLkI4cAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanelBlue);
export default __webpack_public_path__ + "static/media/solar-panel-blue.a483e4ac8e6038d2cb2f213b431d8163.svg";
export { ForwardRef as ReactComponent };